import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

import LeadGenRadioButton from '../../../LeadGenFormItems/LeadGenRadioButton/LeadGenRadioButton';
import LeadGenCheckbox from '../../../LeadGenFormItems/LeadGenCheckbox/LeadGenCheckbox';
import { renderAgreementMessage } from '../../../../shared/renderAgreementMessage';
import { useGetTermsAndConditionsUrl } from '../../../../../hooks/useGetTermsAndConditionsUrl';

import './LeadGenConsentFirstStatements.scss';

function required(value) {
  return value
    ? undefined
    : i18next.t('org.hibernate.validator.constraints.NotEmpty.message');
}

export const Anchor = (props) => {
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a {...props} />;
};

export function LeadGenConsentFirstStatements(props) {
  const {
    consentData: {
      checkboxes = [],
      fallbackQuestion,
      agreementMessage,
      id,
    } = {},
    color,
  } = props;
  const termsAndConditionsUrl = useGetTermsAndConditionsUrl();

  return (
    <div className="c-lead-gen-consent-first-statements">
      {agreementMessage && (
        <div className="c-lead-gen-consent-first-statements__agreement">
          <Field
            component={LeadGenCheckbox}
            isCheckboxGroup={false}
            type="checkbox"
            color={color}
            label={
              <>
                {renderAgreementMessage(
                  agreementMessage,
                  termsAndConditionsUrl,
                )}{' '}
                *
              </>
            }
            name={`userConsentAgreements.${id}`}
            validate={[required]}
          />
        </div>
      )}
      {fallbackQuestion && (
        <div className="c-lead-gen-consent-first-statements__text">
          {fallbackQuestion}
        </div>
      )}
      {checkboxes.length > 0 && (
        <>
          <div className="c-lead-gen-consent-first-statements__checkbox-wrapper">
            {checkboxes.map(({ label, name }) => {
              return (
                <div
                  className="c-lead-gen-consent-first-statements__checkbox"
                  key={name}
                >
                  <Field
                    name={`${id}.${name}`}
                    label={label}
                    component={LeadGenRadioButton}
                    color={color}
                    isRequired
                    validate={[required]}
                    options={[
                      { value: 'true', label: 'Yes' },
                      { value: 'false', label: 'No' },
                    ]}
                  />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

LeadGenConsentFirstStatements.propTypes = {
  consentData: PropTypes.shape({
    agreementMessage: PropTypes.string,
    checkboxes: PropTypes.array,
    fallbackQuestion: PropTypes.string,
    id: PropTypes.string,
  }),
  color: PropTypes.string,
  pageConfig: PropTypes.shape({
    tenantConfig: PropTypes.shape({
      outputName: PropTypes.string,
    }),
    siteType: PropTypes.string,
  }),
  siteHeader: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    pageConfig: state.pageConfig,
    siteHeader: state.siteHeader,
  };
}

export default withTranslation()(
  connect(mapStateToProps)(LeadGenConsentFirstStatements),
);
